import { FiBook } from 'react-icons/fi';
import { SideMenuItem } from '../interfaces/config/sideMenu';

/**
 * Configuration for the application's side navigation menu
 * @type {SideMenuItem[]}
 */
const sideMenu: SideMenuItem[] = [
  {
    title: 'menu.courses',
    path: '/courses',
    icon: FiBook,
  },
];

export default sideMenu;
